import faultTypesService from '../service/faultTypes'
const state = {
    searchResultFaultTypes: {
        total: 0,
        faultTypes: [],
    },
    loading: false
}

const actions = {
    getFaultTypes({ commit }) {
        commit('setLoading', true)
        return faultTypesService.getFaultTypes().then(faultTypes => {
            commit('setfaultTypes', faultTypes);
        }).catch(() => {
            commit('setLoading', false)
        })
    },

}
const mutations = {
    addFaultTypes(state, faultTypes) {
        state.searchResultFaultTypes.faultTypes.push(faultTypes)
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setfaultTypes(state, faultTypes) {
        state.searchResultFaultTypes = faultTypes
        state.loading = false
    },

}
export default {
    namespaced: true,
    state,
    actions,
    mutations
}



